import React from 'react';

const InsuranceResolutionVector = ({ ...props }) => (
  <svg
    width="440"
    height="412"
    viewBox="0 0 440 412"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M436.666 86.0585L313.857 1.36041C312.572 0.474424 311.049 3.27376e-05 309.489 0H131.1C129.546 4.14661e-06 128.028 0.470957 126.746 1.35097L3.34783 86.0596C2.31573 86.7681 1.4715 87.7178 0.888174 88.8266C0.304853 89.9353 2.28418e-06 91.1697 0 92.423V404.286C0 406.332 0.811448 408.294 2.25579 409.741C3.70014 411.187 5.65907 412 7.70168 412H432.298C434.341 412 436.3 411.187 437.744 409.741C439.189 408.294 440 406.332 440 404.286V92.4123C440 91.1618 439.697 89.9302 439.116 88.8233C438.535 87.7165 437.694 86.7676 436.666 86.0585Z"
      fill="#003E7D"
    />
  </svg>
);

export default InsuranceResolutionVector;
